export default "__VITE_ASSET__BssWuVmf__"